var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import ContentLayout from "../../../Layout/ContentLayout";
import usePagedSortedTable, { TotalPageMappers, } from "../../../Hooks/usePagedSortedTable";
import DateService from "../../../../Services/Shared/Date.service";
import { InlineFormFormat } from "../../../UI/FormFormat/FormFormat";
import TextField from "../../../Form/TextField";
import PageTitle from "../../../UI/PageTitle/PageTitle";
import NumberService from "../../../../Services/Shared/Number.service";
import DateRangeField from "../../../Form/DateRangeField";
import LmsCourseResolverErrorService from "../../../../Services/LmsCourseResolverError.service";
const PAGE_SIZE = 50;
const LmsCourseResolverErrorListTable = () => {
    var _a, _b;
    const [searchArgs, setSearchArgs] = React.useState({});
    const { table, dataState } = usePagedSortedTable({
        striped: true,
        hover: true,
        noDataComponent: "No course resolver errors found",
        rowVerticalPadding: 2,
        searchArgs,
        getData: (sort, pageNumber, sArgs) => {
            return LmsCourseResolverErrorService.search({
                courseDataQuery: sArgs.courseDataQuery,
                messageQuery: sArgs.messageQuery,
                createdDateFrom: sArgs.createdDateFrom,
                createdDateTo: sArgs.createdDateTo,
            }, {
                max: PAGE_SIZE,
                offset: pageNumber * PAGE_SIZE,
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
            });
        },
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        columns: [
            {
                title: "ID",
                sortId: "LMS_COURSE_RESOLVER_ERROR_ID",
            },
            {
                title: "Course Section ID",
                sortId: "LMS_COURSE_RESOLVER_ERROR_COURSE_SECTION_ID",
            },
            {
                title: "Course Section Code",
                sortId: "LMS_COURSE_RESOLVER_ERROR_COURSE_SECTION_CODE",
            },
            {
                title: "Course Name",
                sortId: "LMS_COURSE_RESOLVER_ERROR_COURSE_NAME",
            },
            {
                title: "Course ID",
                sortId: "LMS_COURSE_RESOLVER_ERROR_COURSE_ID",
            },
            {
                title: "Course Course ID",
                sortId: "LMS_COURSE_RESOLVER_ERROR_COURSE_COURSE_ID",
            },
            {
                title: "Message",
                sortId: "LMS_COURSE_RESOLVER_ERROR_MESSAGE",
            },
            {
                title: "Created Date",
                sortId: "LMS_COURSE_RESOLVER_ERROR_CREATED_DATE",
            },
        ],
        rows: ({ data }) => data.map((row) => {
            return [
                row.id,
                row.courseSectionId,
                row.courseSectionCode,
                row.courseName,
                row.courseId,
                row.courseCourseId,
                row.message,
                DateService.displayLongWithTimeWithoutWeekday(row.dateCreated),
            ];
        }),
    });
    return (_jsxs(_Fragment, { children: [_jsxs(PageTitle, { className: "mb-3", children: ["Course Resolver Errors", " ", ((_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total)
                        ? `(${NumberService.format((_b = dataState.data) === null || _b === void 0 ? void 0 : _b.total)})`
                        : ""] }), _jsx("div", { className: "text-muted mb-2", children: "Shows a list of course sections from the Lms that could not be found in SS&E, and the reason the validator kicked it out. This report is regenerated each time the Course Resolver runs." }), _jsx("div", { className: "mb-3", children: _jsxs(InlineFormFormat, { saveButtonContents: "Search", handleSubmit: (formState) => __awaiter(void 0, void 0, void 0, function* () {
                        var _c, _d;
                        setSearchArgs({
                            courseDataQuery: formState.courseDataQuery,
                            messageQuery: formState.messageQuery,
                            createdDateFrom: (_c = formState.createdDateFrom) === null || _c === void 0 ? void 0 : _c.toDate(),
                            createdDateTo: (_d = formState.createdDateTo) === null || _d === void 0 ? void 0 : _d.toDate(),
                        });
                    }), children: [_jsx(TextField, { name: "courseDataQuery", label: "Search course data" }), _jsx(TextField, { name: "messageQuery", label: "Search message" }), _jsx(DateRangeField, { nameStart: "createdDateFrom", nameEnd: "createdDateTo", placeHolderStart: "Created Date From", placeHolderEnd: "Created Date To" })] }) }), _jsx("div", { className: "py-2", children: table })] }));
};
const LmsCourseResolverErrorList = () => {
    return (_jsx(ContentLayout, { whiteBackground: true, paddingTop: true, paddingBottom: true, className: "fullMinHeightMinusPrimaryNav", children: _jsx(LmsCourseResolverErrorListTable, {}) }));
};
export default LmsCourseResolverErrorList;
